<template>
  <div class="product-carousel">
    <VueSlickCarousel
      :key="`carousel-${productImages.length}`"
      :dots="true"
      :settings="slickOptions">
      <div v-for="image in productImages" :key="image">
        <img :src="image" alt="Ring">
      </div>
    </VueSlickCarousel>
  </div>
</template> 

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  name: 'ProductCarousel',
  components: { VueSlickCarousel },
  props: {
    productImages: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      slickOptions: {
        arrows: true,
        dots: true,
        swipe: true,
        draggable: true,
        touchMove: true,
        touchThreshold: 100,
        swipeToSlide: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        pauseOnHover: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      }
    }
  }
}
</script>

<style scoped>
.product-carousel {
  width: 100%;
  height: 100%;
  max-height: 433px;
  max-width: 400px;
  position: relative;
}

.product-carousel img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Стилизация точек навигации */
.product-carousel :deep(.slick-dots) {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  display: flex !important;
  justify-content: center;
  align-items: center;
  gap: 8px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.product-carousel :deep(.slick-dots li) {
  width: 12px;
  height: 12px;
  margin: 0;
  padding: 0;
}

.product-carousel :deep(.slick-dots li button) {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #6b7280;
  background: transparent;
  padding: 0;
  margin: 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.product-carousel :deep(.slick-dots li button:hover) {
  border-color: #00fff0;
}

.product-carousel :deep(.slick-dots li.slick-active button) {
  background: #00fff0;
  border-color: #00fff0;
}

.product-carousel :deep(.slick-dots li button:before) {
  display: none;
}
/* Стилизация стрелок навигации */

.product-carousel :deep(.slick-prev) {
  left: 12px;
  z-index: 1;
  width: 32px;
  height: 32px;
}

.product-carousel :deep(.slick-next) {
  right: 12px;
  z-index: 1;
  width: 32px;
  height: 32px;
}

.product-carousel :deep(.slick-prev:before) {
  display: block;
  content: '';  
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' fill='%23000000' transform='matrix(-1, 0, 0, 1, 0, 0)'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Cpath fill='%23000000' d='M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E");

  width: 32px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

.product-carousel :deep(.slick-next:before) {
  display: block;
  content: '';
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 1024 1024' xmlns='http://www.w3.org/2000/svg' fill='%23000000'%3E%3Cg id='SVGRepo_bgCarrier' stroke-width='0'%3E%3C/g%3E%3Cg id='SVGRepo_tracerCarrier' stroke-linecap='round' stroke-linejoin='round'%3E%3C/g%3E%3Cg id='SVGRepo_iconCarrier'%3E%3Cpath fill='%23000000' d='M338.752 104.704a64 64 0 0 0 0 90.496l316.8 316.8-316.8 316.8a64 64 0 0 0 90.496 90.496l362.048-362.048a64 64 0 0 0 0-90.496L429.248 104.704a64 64 0 0 0-90.496 0z'%3E%3C/path%3E%3C/g%3E%3C/svg%3E"); 
 
  width: 32px;
  height: 32px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

@media (max-width: 768px) {
  .product-carousel :deep(.slick-prev),
  .product-carousel :deep(.slick-next) {
    display: none !important;
  }
}

</style>